<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'ecom-sys-thirdPartyApiSet',
  components: {
    PageTable,
  },
}
</script>